import { ItemDto } from '../models/dataTransferObjects/item.dto';
import { ProductDto } from '../models/dataTransferObjects/product.dto';

export class ItemMapper {
    public static toDto(productDto: ProductDto): ItemDto {
        const dto = new ItemDto(productDto, 1);
        return dto
    }
}
